import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'carousel-promotion',
  templateUrl: './carousel-promotion.component.html',
  encapsulation: ViewEncapsulation.None,
})

export class CarouselPromotionComponent {}

